export const InputContainer = {
    position: 'relative',
} as const;
